export default {
  namespaced: true,
  state: {
    vpnConnected: true,
    user: {
      id: null,
      verified: localStorage.getItem('verified', true),
    },
    credentials: {
      email: '',
      password: '',
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    credentials(state) {
      return state.credentials;
    },
    vpnConnected(state) {
      return state.vpnConnected;
    },
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_USER_VPN_CONNECTION_STATUS(state, payload) {
      state.vpnConnected = payload;
    },
    SET_AUTH_CREDENTIAL(state, payload) {
      state.credentials = payload;
    },
    CLEAR_AUTH_CREDENTIAL(state) {
      state.credentials = {
        email: '',
        password: '',
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js